import React, { useId } from 'react'
import PropTypes from 'prop-types'

const LockIcon = React.forwardRef(function LockIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M18 10.56V6C18 2.69 15.31 0 12 0C8.69 0 6 2.69 6 6V10.56C4.81 11.25 4 12.53 4 14V20C4 22.21 5.79 24 8 24H16C18.21 24 20 22.21 20 20V14C20 12.53 19.19 11.25 18 10.56ZM10 16C10 14.9 10.9 14 12 14C13.1 14 14 14.9 14 16C14 16.74 13.59 17.37 13 17.72V20H11V17.72C10.41 17.37 10 16.74 10 16ZM8 6C8 3.79 9.79 2 12 2C14.21 2 16 3.79 16 6V10H8V6Z"></path>
    </svg>
  )
})

LockIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

LockIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default LockIcon
